export default (theme) => ({
  inputField: {
    height: 30,
  },
  inputLabel: {
    fontSize: 13,
  },
  iconToolTip: {
    color: "#898B8E",
    fontSize: ".6rem"
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  textAreaAuto: {
    fontSize: "1rem",
    fontFamily: "inherit",
  },
});
